module.exports = __webpack_public_path__ + "static/img/name.fa1b579.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/tysdags/name.png
// module id = D+Ev
// module chunks = 7